import script from "./BottomToast.vue?vue&type=script&setup=true&lang=js"
export * from "./BottomToast.vue?vue&type=script&setup=true&lang=js"

import "./BottomToast.vue?vue&type=style&index=0&id=4fe4933b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fe4933b"]])

export default __exports__